import { $t } from '@/i18n';
import Cookies from 'js-cookie';
import antdCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import { Lang } from '@/i18n/lang';
const standardLangMap = {
    cn: Lang.Chinese,
    en: Lang.English,
    zh_CN: Lang.Chinese,
    en_US: Lang.English,
    'en-US': Lang.English,
    'zh-CN': Lang.Chinese,
    'zh-TW': 'zh-TW',
    'ko-KR': 'ko-KR',
    'ja-JP': 'ja-JP',
    'ar-KW': 'ar-KW',
    'vi-VN': 'vi-VN',
    'th-TH': 'th-TH',
    'es-ES': 'es-ES',
    'ru-RU': 'ru-RU',
    'it-IT': 'it-IT',
    'fr-FR': 'fr-FR',
};
;
export const getLanguage = () => window.langController.getLang();
export const writeLanguageConfig = (lang) => {
    const finalLang = standardLangMap[lang];
    if (!finalLang) {
        console.error($t('k_ac70ca3d', { arg_0: lang, arg_1: Object.keys(standardLangMap).join(',') }));
        return;
    }
    Cookies.set('lang', finalLang);
};
const getLanguageConfig = async (withTdesign) => {
    const lang = getLanguage();
    const languageMap = {
        tdesign: {
            [standardLangMap.en]: () => import('tdesign-vue/es/locale/en_US'), // en and en_US share the same locale
            [standardLangMap.cn]: async () => ({ default: null }), // td 默认的就是 cn，不需要 import
            [standardLangMap['zh-TW']]: () => import('tdesign-vue/es/locale/zh_TW'),
            [standardLangMap['ja-JP']]: () => import('tdesign-vue/es/locale/ja_JP'),
            [standardLangMap['ko-KR']]: () => import('tdesign-vue/es/locale/ko_KR'),
            [standardLangMap['ru-RU']]: () => import('tdesign-vue/es/locale/ru_RU'),
            [standardLangMap['it-IT']]: () => import('tdesign-vue/es/locale/it_IT'),
            [standardLangMap['ar-KW']]: () => import('tdesign-vue/es/locale/ar_KW'),
            [standardLangMap['fr-FR']]: () => import('@/i18n/tdesign/fr_FR'),
            [standardLangMap['es-ES']]: () => import('@/i18n/tdesign/es_ES'),
            [standardLangMap['vi-VN']]: () => import('@/i18n/tdesign/vi_VN'),
            [standardLangMap['th-TH']]: () => import('@/i18n/tdesign/th_TH'),
        },
        antd: {
            [standardLangMap.en]: () => import('ant-design-vue/lib/locale-provider/en_US'),
            [standardLangMap.cn]: async () => ({ default: antdCN }),
            [standardLangMap['fr-FR']]: () => import('ant-design-vue/lib/locale-provider/fr_FR'),
            [standardLangMap['zh-TW']]: () => import('ant-design-vue/lib/locale-provider/zh_TW'),
            [standardLangMap['ja-JP']]: () => import('ant-design-vue/lib/locale-provider/ja_JP'),
            [standardLangMap['ru-RU']]: () => import('ant-design-vue/lib/locale-provider/ru_RU'),
            [standardLangMap['it-IT']]: () => import('ant-design-vue/lib/locale-provider/it_IT'),
            [standardLangMap['ar-KW']]: () => import('@/i18n/antd/ar-KW'), // antd没有阿拉伯语, 用AI翻译了一版
            [standardLangMap['ko-KR']]: () => import('ant-design-vue/lib/locale-provider/ko_KR'),
            [standardLangMap['es-ES']]: () => import('ant-design-vue/lib/locale-provider/es_ES'),
            [standardLangMap['vi-VN']]: () => import('ant-design-vue/lib/locale-provider/vi_VN'),
            [standardLangMap['th-TH']]: () => import('ant-design-vue/lib/locale-provider/th_TH'),
        },
    };
    const loadPromise = [languageMap.antd[lang]?.()];
    if (withTdesign) {
        loadPromise.push(languageMap.tdesign[lang]?.());
    }
    const [antdLocale, tdesignLocale] = await Promise.all(loadPromise);
    return {
        antdLocale: antdLocale?.default,
        tdesignLocale: tdesignLocale?.default,
    };
};
export default getLanguageConfig;
